import animateScrollTo from 'animated-scroll-to';

export default class HowItWorksHero extends HTMLElement {
  constructor() {
    super();

    // bindings
    this.onClickScrollTo = this.onClickScrollTo.bind(this);

    // privates
    this._node = this;
    this._scroll_to_btn = this._node.querySelectorAll('.scroll-to-btn');

    // events
    this._scroll_to_btn.forEach((el) => {
      el.addEventListener('click', this.onClickScrollTo);
    });
  }

  onClickScrollTo(e) {
    let el = e.currentTarget,
        shopify_section = el.closest('.how-it-works-hero-wrapper'),
        target = shopify_section ? shopify_section.nextElementSibling : false,
        offset = window.innerWidth >= 768 ? 64 : 56;

    if (target) {
      let destination = target.offsetTop - offset;
      if (destination !== window.pageYOffset) {
        animateScrollTo(destination);
      }
    }
  }

  /**
   * Handle unmount.
   */
  disconnectedCallback() {
    this._scroll_to_btn.forEach((el) => {
      el.removeEventListener('click', this.onClickScrollTo);
    });
  }
}
